import $ from 'jquery'

function init () {
  toggleSticky()
  handleConcentButton()
}

function toggleSticky () {
  $('.sticky-container.phone').on('click', function () {
    $('.sticky-info-container').toggleClass('active')
    $('.sticky-container .close-btn').toggleClass('active')
    $('.sticky-container .phone').toggleClass('inactive')
    $('.sticky-container.phone').toggleClass('open')
  })
}

function handleConcentButton () {
  $('#userlinkModalAccept').on('click', function () {
    if (OneTrust) {
      document.getElementById('onetrust-consent-sdk').classList.add('force-unhide')
      OneTrust.ToggleInfoDisplay()
      if (document.getElementById('onetrust-banner-sdk')) {
        document.getElementById('onetrust-banner-sdk').style.display = 'none'
      }

      document.getElementById('close-pc-btn-handler').onclick = function () { OneTrust.Close() }
    }
  })
}

export default {
  init
}
